<div class="p-2 p-lg-3 note-list-shell">
  <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
    <div class="d-flex align-items-center gap-2">
      <span class="icon-pill" style="width:32px;height:32px;background:#d8e9ff;color:#2267c7">
        <lucide-icon [img]="FileTextIcon" [size]="16"></lucide-icon>
      </span>
      <h1 class="title m-0">Credit / Debit Notes</h1>
    </div>
    <button class="btn btn-primary btn-sm d-inline-flex align-items-center gap-2" type="button" (click)="router.navigateByUrl('/credit-debit-notes/new')">
      <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon>
      Add Notes
    </button>
  </div>

  <div class="panel">
    <div class="panel-head d-flex align-items-center justify-content-between gap-2 flex-wrap">
      <span>Notes List</span>
      <div class="search-wrap">
        <lucide-icon class="search-icon" [img]="SearchIcon" [size]="14"></lucide-icon>
        <input class="form-control form-control-sm search-input" [ngModel]="search()" (ngModelChange)="onSearch($event)" placeholder="Search note/client/invoice" />
      </div>
    </div>
    <div class="panel-body p-0">
      <div class="table-responsive">
        <table class="table table-sm mb-0 note-table">
          <thead>
            <tr>
              <th style="width:70px">S.No.</th>
              <th style="min-width:150px">Note ID</th>
              <th style="min-width:130px">Type</th>
              <th style="min-width:130px">Date</th>
              <th style="min-width:200px">Client</th>
              <th style="min-width:160px">Invoice</th>
              <th style="min-width:140px" class="text-end">Total</th>
              <th style="min-width:240px">Remarks</th>
              <th style="min-width:140px">Actions</th>
            </tr>
          </thead>
          <tbody>
            @if (loading()) {
              <tr>
                <td colspan="9" class="text-center py-5 text-muted fw-semibold">Loading...</td>
              </tr>
            } @else if (filteredNotes().length === 0) {
              <tr>
                <td colspan="9" class="text-center py-5 text-muted fw-semibold">No notes found</td>
              </tr>
            } @else {
              @for (row of filteredNotes(); track row.id; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ row.id }}</td>
                  <td>{{ row.note_type || '-' }}</td>
                  <td>{{ row.note_date || '-' }}</td>
                  <td>{{ row.client_name || '-' }}</td>
                  <td>{{ row.invoice_id || '-' }}</td>
                  <td class="text-end">{{ formatAmount(row.total_amount) }}</td>
                  <td>{{ row.remarks || '-' }}</td>
                  <td>
                    <button type="button" class="btn btn-light btn-sm me-1" title="Edit" (click)="editNote(row)">
                      <lucide-icon [img]="PencilIcon" [size]="13"></lucide-icon>
                    </button>
                    <button type="button" class="btn btn-light btn-sm" title="Generate PDF" (click)="downloadNotePdf(row)">
                      <lucide-icon [img]="DownloadIcon" [size]="13"></lucide-icon>
                    </button>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
